import { CSSProperties, useEffect, useState } from "react";

const getCssProperties = (props: any): CSSProperties => {
    if (props) {
        const styles = {} as any;

        // Height desktop

        if (props?.height) {
            styles["--height-desktop"] = `${Number(props?.height)}px`;
        }

        // Height mobile

        if (props?.mobileHeight) {
            styles["--height-mobile"] = `${Number(props?.mobileHeight)}px`;
        }

        // Height Tablet

        if (props?.tabletHeight) {
            styles["--height-tablet"] = `${Number(props?.tabletHeight)}px`;
        }
        return styles;
    }
    return {};
};

export default (props: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(props));

    useEffect(() => {
        setResult(getCssProperties(props));
    }, [props]);

    return result;
};